export const USER_CHECK = 'USER_CHECK'
export const USER_LOGIN = 'USER_LOGIN'
export const USER_LOGOUT = 'USER_LOGOUT'
export const USER_REGISTER = 'USER_REGISTER'
export const USER_SOCIAL = 'USER_SOCIAL'

export default 'types'
